// extracted by mini-css-extract-plugin
export default {"container":"profile_container__ioMi2","navigation":"profile_navigation__agG5A","list":"profile_list__Lc82j","link":"profile_link__vF9As","text":"profile_text__c3Cw4"};